export const drawOptionDescription = (parent, description, style) => {
    if (!description)
        return;
    const descriptionEl = document.createElement("label");
    if (style)
        Object.assign(descriptionEl.style, style);
    descriptionEl.innerHTML = description;
    parent.appendChild(descriptionEl);
};
